import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import type { Editor as TinyMCEEditor } from 'tinymce';
import { TextEditorProps } from './TextEditor.types';

const TextEditor: React.FC<TextEditorProps> = ({
  initialValue,
  height = '70vh',
  onChange,
  toolbarOptions,
  value,
}) => {
  const editorRef = useRef<TinyMCEEditor | null>(null);

  const editorConfig = {
    height: height,
    menu: {
      file: {
        title: 'File',
        items:
          'newdocument restoredraft | preview | importword exportpdf exportword | print | deleteallconversations',
      },
      edit: {
        title: 'Edit',
        items:
          'undo redo | cut copy paste pastetext | selectall | searchreplace',
      },
      view: {
        title: 'View',
        items:
          'code revisionhistory | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments',
      },
      insert: {
        title: 'Insert',
        items:
          'image link media addcomment pageembed codesample inserttable | math | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime',
      },
      format: {
        title: 'Format',
        items:
          'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount',
      },
      table: {
        title: 'Table',
        items:
          'inserttable | cell row column | advtablesort | tableprops deletetable',
      },
      help: { title: 'Help', items: 'help' },
    },
    branding: false,
    language: 'fr_FR',
    toolbar:
      toolbarOptions ||
      'undo redo print spellcheckdialog formatpainter | blocks fontfamily fontsize fontsizeinput | bold italic underline strikethrough subscript superscript forecolor backcolor | link image hr blockquote | alignleft aligncenter alignright alignjustify alignnone lineheight | checklist bullist numlist indent outdent | removeformat remove | h1 h2 h3 h4 h5 h6 | accordion accordiontoggle accordionremove math',
    plugins: [
      'advlist',
      'autolink',
      'lists',
      'link',
      'image',
      'charmap',
      'preview',
      'anchor',
      'searchreplace',
      'visualblocks',
      'code',
      'fullscreen',
      'insertdatetime',
      'media',
      'table',
      'wordcount',
      'accordion',
      'math',
    ],
    content_style: `
    a {
      background-color: #FEC200;
      color: black;
      text-decoration: underline;
    }
  `,
  };

  return (
    <>
      <Editor
        apiKey={
          process.env.TINYMCE_API_KEY || process.env.REACT_APP_TINYMCE_API_KEY
        }
        // onInit={(_evt, editor) => (editorRef.current = editor)}
        // onEditorChange={onChange}
        // initialValue={initialValue ? initialValue : undefined}
        // value={value}
        // init={editorConfig}
      />
    </>
  );
};

export default TextEditor;
